import React from 'react';
import Home from './components/Home';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Skills from './components/Skills';
import Header from './components/Header';
import Footer from './components/Footer';
import { Route, HashRouter, Routes, BrowserRouter as Router } from 'react-router-dom';

import './index.css';

function App() {
  //changed Router to HashRouter below

  return (
    <div className="flex flex-col min-h-screen">
      <main className='flex-grow'>
        <Router> 
          <Header/>
            <Routes>
              <Route path='/' element={<Home/>}/>
              <Route path='/Projects' element={<Projects/>}/>
              <Route path='/Contact' element={<Contact/>}/>
              <Route path='/Skills' element={<Skills/>}/>
            </Routes>
        </Router>
        </main>
        <Footer/>
    </div>
  );
}

export default App;

